import Scrollbar from './Scrollbar';
import SimpleScrollbar from './SimpleScrollbar';
export { scrollbarProps } from './Scrollbar';
export { simpleScrollbarProps } from './SimpleScrollbar';
Scrollbar.SimpleScrollbar = SimpleScrollbar;
Scrollbar.install = function (app) {
    app.component(Scrollbar.name, Scrollbar);
    app.component(Scrollbar.SimpleScrollbar.name, Scrollbar.SimpleScrollbar);
    return app;
};
export { SimpleScrollbar };
export default Scrollbar;
